import React from 'react';
import { useTranslation } from 'react-i18next';

import { Feature, TextareaField, TextField } from '@mssgme/ui';
import { FieldTip } from '@mssgme/app/components/UI';
import CardEditForm from '../CardEditForm';

export default function SeoEdit() {
    const { t } = useTranslation('cards');

    return (
        <CardEditForm title={t('SeoEdit.title')} backPath="/p/settings" successRedirectPath="/p/settings">
            {({ values }) => (
                <Feature rule="seo">
                    <TextField
                        label={t('SeoEdit.labels.title')}
                        name="seo.title"
                        placeholder={values.profile.fullname}
                        maxLength={80}
                        autoFocus
                    />
                    <TextareaField
                        label={t('SeoEdit.labels.description')}
                        name="seo.description"
                        placeholder={values.profile.description}
                        maxLength={200}
                        maxRows={4}
                    />
                    <FieldTip>{t('FieldTip.seo')}</FieldTip>
                </Feature>
            )}
        </CardEditForm>
    );
}
